(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5537],{

/***/ 35035:
/***/ (function(module) {

"use strict";


module.exports = function (data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = { cmp: opts };
    var cycles = (typeof opts.cycles === 'boolean') ? opts.cycles : false;

    var cmp = opts.cmp && (function (f) {
        return function (node) {
            return function (a, b) {
                var aobj = { key: a, value: node[a] };
                var bobj = { key: b, value: node[b] };
                return f(aobj, bobj);
            };
        };
    })(opts.cmp);

    var seen = [];
    return (function stringify (node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') {
            node = node.toJSON();
        }

        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);

        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for (i = 0; i < node.length; i++) {
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }

        if (node === null) return 'null';

        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }

        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for (i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = stringify(node[key]);

            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    })(data);
};


/***/ }),

/***/ 22209:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/card-cadou",
      function () {
        return __webpack_require__(39431);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 66707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lib_useElementSize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56055);



var AccordionItemBody = function(param) {
    var children = param.children, isExpanded = param.isExpanded, isPreRendered = param.isPreRendered;
    var onContentSizeChange = function onContentSizeChange(size) {
        if (size && contentHeight !== size) {
            setContentHeight("".concat(size.height, "px"));
        }
    };
    // Using height 100% doesn't break functionality
    // despite animations not working
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isContainerRendered = ref[0], setIsContainerRendered = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("100%"), contentHeight = ref1[0], setContentHeight = ref1[1];
    var setContainerRef = (0,_lib_useElementSize__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(onContentSizeChange);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isExpanded || isPreRendered) {
            setIsContainerRendered(true);
        }
    }, [
        isExpanded,
        isPreRendered
    ]);
    var containerHeight = isExpanded ? contentHeight : 0;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "overflow-hidden transition-[height] ease-in-out duration-[300ms]",
        style: {
            height: containerHeight
        },
        children: isContainerRendered && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            ref: setContainerRef,
            className: "pb-8",
            children: children
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (AccordionItemBody);


/***/ }),

/***/ 85929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Header; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/Icons/ArrowDown.js
var ArrowDown = __webpack_require__(26206);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
;// CONCATENATED MODULE: ./components/Accordion/Item/HeaderToggleButton.js



var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, websiteName = _publicRuntimeConfig.settings.websiteName;
var isBricoStore = websiteName === "bricostore";
var HeaderToggleButton = function(param) {
    var onToggle = param.onToggle, isExpanded = param.isExpanded;
    // TODO: website-next - Replace with Button component
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("button", {
        className: isBricoStore ? "rounded-full bg-gray-lighter px-3 py-2" : "rounded bg-filterYellow px-3 py-2",
        onClick: onToggle,
        children: isExpanded ? "Ascunde" : "Detalii"
    });
};
/* harmony default export */ var Item_HeaderToggleButton = (HeaderToggleButton);

;// CONCATENATED MODULE: ./components/Accordion/Item/Header.js



var AccordionItemHeader = function(param) {
    var isExpanded = param.isExpanded, isToggleable = param.isToggleable, _hasToggleButton = param.hasToggleButton, hasToggleButton = _hasToggleButton === void 0 ? false : _hasToggleButton, renderToggleButton = param.renderToggleButton, onToggle = param.onToggle, children = param.children;
    if (!hasToggleButton) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center justify-between py-7 ".concat(isToggleable ? "cursor-pointer" : ""),
            onClick: onToggle,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: children
                }),
                isToggleable && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "transition-transform ease-linear ".concat(isExpanded ? "rotate-180" : "rotate-0"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                        width: "16px",
                        height: "16px"
                    })
                })
            ]
        }));
    }
    var toggleButton = renderToggleButton && renderToggleButton({
        toggleItem: onToggle,
        isItemExpanded: isExpanded
    }) || /*#__PURE__*/ (0,jsx_runtime.jsx)(Item_HeaderToggleButton, {
        isExpanded: isExpanded,
        onToggle: onToggle
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center justify-between py-4 ",
        children: [
            children,
            isToggleable && toggleButton
        ]
    }));
};
/* harmony default export */ var Header = (AccordionItemHeader);


/***/ }),

/***/ 4259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_Accordion_accordionContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84849);



var AccordionItem = function(param) {
    var id = param.id, children = param.children, _isPreRendered = param.isPreRendered, isPreRendered = _isPreRendered === void 0 ? true : _isPreRendered;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_components_Accordion_accordionContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z), onItemToggle = ref.onItemToggle, isItemToggleable = ref.isItemToggleable, isItemExpanded = ref.isItemExpanded;
    var handleToggle = function(event) {
        return onItemToggle(id, event);
    };
    var isExpanded = isItemExpanded(id);
    var isToggleable = isItemToggleable(id);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: id,
        children: react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, function(child) {
            /*#__PURE__*/ return (0,react__WEBPACK_IMPORTED_MODULE_1__.isValidElement)(child) ? /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(child, {
                id: id,
                isPreRendered: isPreRendered,
                isExpanded: isExpanded,
                isToggleable: isToggleable,
                onToggle: handleToggle
            }) : child;
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (AccordionItem);


/***/ }),

/***/ 84849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var AccordionContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
/* harmony default export */ __webpack_exports__["Z"] = (AccordionContext);


/***/ }),

/***/ 71604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Accordion; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/Accordion/useAccordion.js

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var useAccordion = function(param) {
    var _mode = param.mode, mode = _mode === void 0 ? "closable" : _mode, _expandedItems = param.expandedItems, expandedItems = _expandedItems === void 0 ? [] : _expandedItems, _onToggle = param.onToggle, onToggle = _onToggle === void 0 ? function() {} : _onToggle;
    if (![
        "closable",
        "always-one",
        "max-one"
    ].includes(mode)) {
        throw new Error("Unrecognized \"".concat(mode, "\" for Accordion"));
    }
    if (mode === "always-one" && expandedItems.length !== 1) {
        throw new Error("always-one mode requires only one initial item");
    }
    if (mode === "max-one" && expandedItems.length > 1) {
        throw new Error("max-one mode allows none or only one initial item");
    }
    var ref = (0,react.useState)(expandedItems), expanded = ref[0], setExpanded = ref[1];
    var isItemExpanded = function(item) {
        return expanded === null || expanded === void 0 ? void 0 : expanded.includes(item);
    };
    var isItemToggleable = function(item) {
        return mode === "always-one" ? !isItemExpanded(item) : true;
    };
    (0,react.useEffect)(function() {
        setExpanded(expandedItems);
    }, [
        expandedItems
    ]);
    var onItemToggle = function(item, event) {
        switch(mode){
            case "always-one":
                {
                    if (!isItemExpanded(item)) {
                        setExpanded([
                            item
                        ]);
                        onToggle({
                            item: item,
                            expanded: true
                        }, event);
                    }
                    break;
                }
            case "max-one":
                {
                    if (isItemExpanded(item)) {
                        setExpanded([]);
                        onToggle({
                            item: item,
                            expanded: false
                        }, event);
                    } else {
                        setExpanded([
                            item
                        ]);
                        onToggle({
                            item: item,
                            expanded: true
                        }, event);
                    }
                    break;
                }
            case "closable":
            default:
                {
                    if (isItemExpanded(item)) {
                        setExpanded(expanded.filter(function(expandedItem) {
                            return item !== expandedItem;
                        }));
                        onToggle({
                            item: item,
                            expanded: false
                        }, event);
                    } else {
                        setExpanded(_toConsumableArray(expanded).concat([
                            item
                        ]));
                        onToggle({
                            item: item,
                            expanded: true
                        }, event);
                    }
                }
        }
    };
    return {
        isItemToggleable: isItemToggleable,
        isItemExpanded: isItemExpanded,
        onItemToggle: onItemToggle
    };
};
/* harmony default export */ var Accordion_useAccordion = (useAccordion);

// EXTERNAL MODULE: ./components/Accordion/accordionContext.js
var accordionContext = __webpack_require__(84849);
;// CONCATENATED MODULE: ./components/Accordion/index.js



var Accordion = function(param) {
    var mode = param.mode, expandedItems = param.expandedItems, onToggle = param.onToggle, children = param.children;
    var ref = Accordion_useAccordion({
        mode: mode,
        expandedItems: expandedItems,
        onToggle: onToggle
    }), isItemExpanded = ref.isItemExpanded, isItemToggleable = ref.isItemToggleable, onItemToggle = ref.onItemToggle;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(accordionContext/* default.Provider */.Z.Provider, {
        value: {
            isItemExpanded: isItemExpanded,
            isItemToggleable: isItemToggleable,
            onItemToggle: onItemToggle
        },
        children: children
    }));
};
/* harmony default export */ var components_Accordion = (Accordion);


/***/ }),

/***/ 94512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./lib/structuredData.js
var structuredData = __webpack_require__(89229);
;// CONCATENATED MODULE: ./components/BreadcrumbSchema.js




var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, baseUrl = _publicRuntimeConfig.settings.baseUrl;
var BreadcrumbSchema = function(param) {
    var breadcrumbData = param.breadcrumbData, currentPath = param.currentPath;
    // Do not include home page
    // Do not include pages without parent
    if (breadcrumbData && breadcrumbData.length > 1) {
        var itemListElement = breadcrumbData.map(function(breadcrumb, index) {
            return {
                "@type": "ListItem",
                position: index + 1,
                name: breadcrumb.name,
                item: breadcrumb.level != 99 ? "".concat(baseUrl, "/").concat(breadcrumb.url_key).concat(breadcrumb.url_suffix || "") : "".concat(baseUrl).concat(currentPath)
            };
        });
        var schema = {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: itemListElement
        };
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: (0,structuredData/* default */.Z)(schema)
            }
        }));
    }
    return null;
};
/* harmony default export */ var components_BreadcrumbSchema = (BreadcrumbSchema);

;// CONCATENATED MODULE: ./components/Breadcrumbs.js








var Breadcrumbs_ref = (0,config["default"])(), settings = Breadcrumbs_ref.publicRuntimeConfig.settings;
var isBricoStore = settings.websiteName === "bricostore";
var Breadcrumbs = function(param) {
    var breadcrumbs = param.breadcrumbs, _isPDP = param.isPDP, isPDP = _isPDP === void 0 ? false : _isPDP, className = param.className;
    var router = (0,next_router.useRouter)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            breadcrumbs && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BreadcrumbSchema, {
                breadcrumbData: breadcrumbs,
                currentPath: router.asPath
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "Breadcrumbs is-hidden-in-mobile-app pb-3 lg:py-3 truncate text-sm ".concat(className),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                    className: "p-0 m-0 list-none inline",
                    children: breadcrumbs.map(function(breadcrumb, index) {
                        return breadcrumb.level != 99 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: classnames_default()("inline", {
                                "text-red-brand": isBricoStore || !isPDP,
                                "text-[#1D4ED8]": !isBricoStore && isPDP
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "".concat(settings.baseUrl, "/").concat(breadcrumb.url_key).concat(breadcrumb.url_suffix || ""),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        title: breadcrumb.name,
                                        className: classnames_default()({
                                        }),
                                        children: breadcrumb.name
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mx-1",
                                    children: "/"
                                })
                            ]
                        }, "".concat(breadcrumb.level, "-").concat(breadcrumb.id, "-").concat(index)) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "inline",
                            children: breadcrumb.name
                        }, "".concat(breadcrumb.level, "-").concat(breadcrumb.id, "-").concat(index));
                    })
                })
            })
        ]
    }));
};
Breadcrumbs.propTypes = {
    breadcrumbs: prop_types_default().arrayOf(prop_types_default().shape({
        id: (prop_types_default()).number.isRequired,
        level: (prop_types_default()).number.isRequired,
        name: (prop_types_default()).string.isRequired,
        url_key: function(props, propName) {
            if (props["level"] !== 99 && (typeof props[propName] !== "string" || props[propName].length === 0)) {
                return new Error("Please provide url_key when item level is not 99.");
            }
        },
        url_suffix: (prop_types_default()).string
    })).isRequired
};
/* harmony default export */ var components_Breadcrumbs = (Breadcrumbs);


/***/ }),

/***/ 4792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Textarea = function(props) {
    var input = props.input, children = props.children, rows = props.rows, _meta = props.meta, touched = _meta.touched, error = _meta.error;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex justify-between items-center",
                children: props.label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                    htmlFor: props.id,
                    className: "Form-label ".concat(props.required ? "is-required" : "", " ").concat(props.disabled ? "disabled" : "", " ").concat(props.labelClass),
                    children: typeof props.label === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: props.label
                        },
                        className: "inline-block"
                    }) : props.label
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", _objectSpread({}, input, {
                required: props.required,
                disabled: props.disabled,
                placeholder: props.placeholder,
                autoCorrect: props.autoCorrect,
                rows: rows,
                className: props.className ? "".concat(props.className, " ").concat(touched && error ? "error" : "") : "w-full text-black ".concat(props.inputClassName, " ").concat(touched && error ? "error" : ""),
                children: children
            })),
            touched && error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-red-brand text-sm",
                children: error
            })
        ]
    }));
};
Textarea.defaultProps = {
    id: undefined,
    label: undefined,
    required: undefined,
    disabled: undefined,
    placeholder: undefined,
    rows: undefined,
    autoCorrect: undefined
};
/* harmony default export */ __webpack_exports__["Z"] = (Textarea);


/***/ }),

/***/ 89229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35035);
/* harmony import */ var fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0__);

// JSON-LD blocks are injected with dangerouslySetInnerHTML, so a "<" coming
// from product data (a "</script>" inside a product name or description) would
// close the script element early and make the whole block unparsable for
// crawlers, besides letting the markup run in the browser. These characters
// are only ever part of JSON string values, where the escaped form is
// equivalent, so escaping them keeps the JSON valid and the page safe.
var HTML_UNSAFE_ESCAPES = {
    "<": "\\u003c",
    ">": "\\u003e",
    "&": "\\u0026"
};
var serializeSchema = function(schema) {
    return fast_json_stable_stringify__WEBPACK_IMPORTED_MODULE_0___default()(schema).replace(/[<>&]/g, function(character) {
        return HTML_UNSAFE_ESCAPES[character];
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (serializeSchema);


/***/ }),

/***/ 56055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useElementSize = function(setElementSize) {
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), height = ref3[0], setHeight = ref3[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), width = ref1[0], setWidth = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var setElementRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(element) {
        return ref2.current = element;
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (ref2.current) {
            var callback = function(entries) {
                entries.forEach(function(entry) {
                    var ref;
                    if ((ref = entry.borderBoxSize) === null || ref === void 0 ? void 0 : ref[0]) {
                        var newHeight = entry.borderBoxSize[0].blockSize;
                        var newWidth = entry.borderBoxSize[0].inlineSize;
                        if (height !== newHeight || width !== newWidth) {
                            setElementSize({
                                height: newHeight,
                                width: newWidth
                            });
                            setHeight(newHeight);
                            setWidth(newWidth);
                        }
                    }
                });
            };
            try {
                var observer = new ResizeObserver(callback);
                observer.observe(ref2.current);
                return function() {
                    return observer.disconnect();
                };
            } catch (error) {
            // No Resize Observer
            }
        }
    }, [
        ref2,
        setElementSize
    ]);
    return setElementRef;
};
/* harmony default export */ __webpack_exports__["Z"] = (useElementSize);


/***/ }),

/***/ 39431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ card_cadou; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
// EXTERNAL MODULE: ./node_modules/react-final-form-listeners/dist/react-final-form-listeners.es.js
var react_final_form_listeners_es = __webpack_require__(73337);
// EXTERNAL MODULE: ./containers/Catalog/Actions/AddToCart.js + 6 modules
var AddToCart = __webpack_require__(38973);
// EXTERNAL MODULE: ./components/Form/InputText.js + 2 modules
var InputText = __webpack_require__(58833);
// EXTERNAL MODULE: ./components/Form/Textarea.js
var Textarea = __webpack_require__(4792);
// EXTERNAL MODULE: ./lib/validations.js + 1 modules
var validations = __webpack_require__(38294);
;// CONCATENATED MODULE: ./components/GiftCardForm.js









var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, _settings = _publicRuntimeConfig.settings, websiteName = _settings.websiteName, giftCard = _settings.giftCard;
// If changing these values, make sure to change values in card-cadou page as well
// "Cardurile cadou pot avea valoarea.."
var DEFAULT_VALUES = [
    200,
    300,
    500,
    1000
];
var MIN_VALUE = 200;
var MAX_VALUE = 5000;
var GiftCardForm = function(param1) {
    var user = param1.user;
    var customer = user.customer;
    var ref6 = (0,react.useState)(false), customValue = ref6[0], setCustomValue = ref6[1];
    var ref1 = (0,react.useState)(""), senderName = ref1[0], setSenderName = ref1[1];
    var ref2 = (0,react.useState)(""), senderMessage = ref2[0], setSenderMessage = ref2[1];
    var ref3 = (0,react.useState)(""), receiverName = ref3[0], setReceiverName = ref3[1];
    var ref4 = (0,react.useState)(""), receiverEmail = ref4[0], setReceiverEmail = ref4[1];
    var ref5 = (0,react.useState)(DEFAULT_VALUES[2]), giftCardValue = ref5[0], setGiftCardValue = ref5[1];
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
        onSubmit: function() {},
        initialValues: {
            sender_name: "".concat((customer === null || customer === void 0 ? void 0 : customer.first_name) || "", " ").concat((customer === null || customer === void 0 ? void 0 : customer.last_name) || "")
        },
        validate: function(values) {
            var errors = {};
            if (values.receiver_email && values.receiver_email_confirmation && values.receiver_email !== values.receiver_email_confirmation) {
                errors.receiver_email_confirmation = "Adresele de email nu corespund";
            }
            return errors;
        },
        render: function(param) {
            var handleSubmit = param.handleSubmit, submitting = param.submitting, pristine = param.pristine, invalid = param.invalid;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("form", {
                className: "w-full",
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col md:flex-row items-stretch justify-center w-full space-y-4 md:space-y-0 md:space-x-10 px-2 md:px-0 mt-12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col items-start justify-start w-full h-full space-y-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "w-full leading-8 md:leading-10 text-2xl xl:text-3xl text-black font-normal",
                                        children: "Detalii expeditor"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-full",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                                className: "!w-full !max-w-full",
                                                name: "sender_name",
                                                label: "Numele expeditor",
                                                type: "text",
                                                component: InputText/* default */.Z,
                                                required: true,
                                                validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMinLength */.vd)(3), (0,validations/* hasMaxLength */.aG)(60))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_listeners_es/* OnChange */.GU, {
                                                name: "sender_name",
                                                children: function(value) {
                                                    return setSenderName(value);
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-full",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                                className: "!w-full !max-w-full h-32",
                                                name: "sender_message",
                                                label: "Mesaj pentru destinatar",
                                                type: "textarea",
                                                component: Textarea/* default */.Z,
                                                required: true,
                                                validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMinLength */.vd)(3), (0,validations/* hasMaxLength */.aG)(250))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_listeners_es/* OnChange */.GU, {
                                                name: "sender_message",
                                                children: function(value) {
                                                    return setSenderMessage(value);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-sm w-full",
                                                children: "*Cardul va fi emis pe e-mail in maximum 24 de ore de la plata comenzii."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col items-center justify-start w-full h-full space-y-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "w-full leading-8 md:leading-10 text-2xl xl:text-3xl text-black font-normal",
                                        children: "Detalii destinatar"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-full",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                                className: "!w-full !max-w-full",
                                                name: "receiver_name",
                                                label: "Nume destinatar",
                                                type: "text",
                                                component: InputText/* default */.Z,
                                                required: true,
                                                validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* hasMinLength */.vd)(3), (0,validations/* hasMaxLength */.aG)(60))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_listeners_es/* OnChange */.GU, {
                                                name: "receiver_name",
                                                children: function(value) {
                                                    return setReceiverName(value);
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-full",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                                className: "!w-full !max-w-full",
                                                name: "receiver_email",
                                                label: "E-mail destinatar",
                                                type: "email",
                                                component: InputText/* default */.Z,
                                                required: true,
                                                validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* isEmail */.Jh)(), (0,validations/* hasMaxLength */.aG)(80))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_listeners_es/* OnChange */.GU, {
                                                name: "receiver_email",
                                                children: function(value) {
                                                    return setReceiverEmail(value);
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-full",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                            className: "!w-full !max-w-full",
                                            name: "receiver_email_confirmation",
                                            label: "Confirmare e-mail destinatar",
                                            type: "email",
                                            component: InputText/* default */.Z,
                                            required: true,
                                            validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), (0,validations/* isEmail */.Jh)(), (0,validations/* hasMaxLength */.aG)(80))
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col space-y-6 items-center justify-center px-2 py-5 md:py-10 md:px-16 w-full bg-[#F7F9FF] rounded-tr-xl rounded-bl-xl mt-12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "w-full leading-8 md:leading-10 text-2xl xl:text-3xl text-black font-normal text-center",
                                children: "Alege valoarea cardului cadou"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "flex flex-col md:flex-row items-center space-y-2 md:space-x-2 md:space-y-0 justify-center w-full",
                                children: [
                                    DEFAULT_VALUES.map(function(value) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                            className: "w-full md:w-32",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                className: "flex items-center justify-center w-full p-2 text-lg rounded-tr-lg rounded-bl-lg outline-none cursor-pointer border-primary border-2 ".concat(giftCardValue === value && !customValue ? "bg-primary ".concat(websiteName === "altex" ? "text-black" : "text-white") : ""),
                                                onClick: function() {
                                                    setGiftCardValue(value);
                                                    setCustomValue(function(previous) {
                                                        return previous && false;
                                                    });
                                                },
                                                children: [
                                                    value,
                                                    " lei"
                                                ]
                                            })
                                        }, value);
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "w-full md:w-32",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "flex items-center justify-center w-full p-2 text-lg rounded-tr-lg rounded-bl-lg outline-none cursor-pointer border-primary border-2 ".concat(customValue ? "bg-primary ".concat(websiteName === "altex" ? "text-black" : "text-white") : ""),
                                            onClick: function() {
                                                return setCustomValue(true);
                                            },
                                            children: "Alta suma"
                                        })
                                    }, "custom")
                                ]
                            }),
                            customValue && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full max-w-[810px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                                        className: "!w-full !max-w-full",
                                        name: "custom_value",
                                        type: "text",
                                        component: InputText/* default */.Z,
                                        validate: (0,validations/* composeFormValidators */.JT)((0,validations/* isRequired */.q9)(), // isNumber(),
                                        (0,validations/* isInteger */.U)(), (0,validations/* isInRange */.mh)(MIN_VALUE, MAX_VALUE))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_listeners_es/* OnChange */.GU, {
                                        name: "custom_value",
                                        children: function(value) {
                                            var parsed = parseInt(value.replace(/\D/g, ""));
                                            if (!isNaN(parsed)) setGiftCardValue(parsed);
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center justify-center w-full mt-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCart/* default */.Z, {
                            classNames: "w-full md:w-80",
                            product: {
                                gift_card: giftCardValue,
                                sku: giftCard.sku,
                                quantity: 1,
                                seller_id: 1,
                                additional_data: {
                                    gift_card: {
                                        theme: "standard",
                                        from_name: senderName,
                                        message: senderMessage,
                                        to_name: receiverName,
                                        to_email: receiverEmail,
                                        value: giftCardValue
                                    }
                                }
                            },
                            disabled: submitting || pristine || invalid
                        })
                    })
                ]
            });
        }
    }));
};
/* harmony default export */ var components_GiftCardForm = (GiftCardForm);

// EXTERNAL MODULE: ./components/Breadcrumbs.js + 1 modules
var Breadcrumbs = __webpack_require__(94512);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./components/Accordion/index.js + 1 modules
var Accordion = __webpack_require__(71604);
// EXTERNAL MODULE: ./components/Accordion/Item/index.js
var Item = __webpack_require__(4259);
// EXTERNAL MODULE: ./components/Accordion/Item/Header.js + 1 modules
var Header = __webpack_require__(85929);
// EXTERNAL MODULE: ./components/Accordion/Item/Body.js
var Body = __webpack_require__(66707);
// EXTERNAL MODULE: ./components/Heading.js
var Heading = __webpack_require__(73510);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./lib/helpers.js
var helpers = __webpack_require__(15722);
;// CONCATENATED MODULE: ./pages/card-cadou.js







// import { Tabs, Tab } from "@components/ProductTabs"; //? Remove after codereview








// import GiftCardIcon from "@components/Icons/GiftCardIcon";
var card_cadou_ref = (0,config["default"])(), card_cadou_publicRuntimeConfig = card_cadou_ref.publicRuntimeConfig, websiteTitle = card_cadou_publicRuntimeConfig.content.websiteTitle, card_cadou_settings = card_cadou_publicRuntimeConfig.settings, websiteStatics = card_cadou_settings.websiteStatics, card_cadou_websiteName = card_cadou_settings.websiteName;
var GiftCard = function(param1) {
    var user = param1.user;
    var asPath = (0,router.useRouter)().asPath;
    var ref1 = (0,react.useState)(""), openedSection = ref1[0], setOpenedSection = ref1[1];
    (0,react.useEffect)(function() {
        var hash = asPath.split("#")[1];
        if (hash) {
            var hashSlug = (0,helpers/* getSlug */.QF)(hash);
            var sectionElement = document.getElementById(hashSlug);
            if (sectionElement) {
                setOpenedSection(hashSlug);
            }
        }
    }, []);
    var onAccordionItemToggle = function(param) {
        var item = param.item, expanded = param.expanded;
        return history.replaceState({}, "", "#".concat(expanded ? item : ""));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                        children: [
                            "Card Cadou ",
                            websiteTitle,
                            " 🎁 Daruieste un cadou special - Gift Card",
                            " ",
                            websiteTitle
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Cumpara un Card Cadou ".concat(websiteTitle, " si ofera celor apropiati un cadou diferit! ⭐ Acum cu un Gift Card ").concat(websiteTitle, " ei pot sa achizitioneze exact ceea ce isi doresc. ✔️ ").concat(websiteTitle)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: "card, cadou, gift, dar"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                breadcrumbs: [
                    {
                        id: 1,
                        level: 99,
                        name: "Carduri cadou"
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center justify-center w-full space-y-8 mt-10",
                children: [
                    card_cadou_websiteName !== "bricostore" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "block md:hidden w-full bg-[#F7F9FF] rounded-xl",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "".concat(websiteStatics, "/images/giftcard-banner-mobile.png"),
                                    alt: "Daruieste celor dragi un card cadou virtual!"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hidden md:block w-full bg-[#F7F9FF] rounded-xl",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "".concat(websiteStatics, "/images/giftcard-banner.png"),
                                    alt: "Daruieste celor dragi un card cadou virtual!"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_GiftCardForm, {
                        user: user
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        className: "font-normal text-2xl leading-10 md:text-3xl md:leading-42 w-full",
                        children: [
                            "Card Cadou ",
                            websiteTitle
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-base",
                        children: [
                            "Lasa-te inspirat de cea mai simpla varianta de a oferi un cadou, cu noile carduri cadou virtuale de la ",
                            websiteTitle,
                            ", numai bune de daruit celor dragi. Acest card cadou iti permite sa oferi cadou o suma cuprinsa intre 200 si 5000 de lei ce poate fi folosita la achizitionarea oricarui* produs din",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "font-semibold text-red-brand",
                                    children: websiteTitle
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-base",
                        children: [
                            "Cardul cadou virtual poate fi folosit la achizitionarea oricarui produs* din site-ul",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "font-semibold text-red-brand",
                                    children: websiteTitle
                                })
                            }),
                            ", mai putin Asigurari, Cartele Prepaid, cat si pentru achizitionarea produselor vandute si livrate de catre Partenerii Altex Marketplace, produse evidentiate in site ca fiind \"Vandut si livrat de: [plus denumirea Partenerului Altex Marketplace]."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        // TODO: add href for bricostore giftcard??
                        href: card_cadou_websiteName === "altex" ? "https://lcdn.altex.ro/media/custom/upload/regulament-card-cadou-virtual-altex.pdf" : "https://lcdn.mediagalaxy.ro/media/custom/upload/regulament-card-cadou-virtual-mediagalaxy.pdf",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "font-semibold text-red-brand w-full",
                            children: "Regulament"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "space-y-2 py-2 divide-y divide-black/30 border-y",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                                expandedItems: openedSection,
                                onToggle: onAccordionItemToggle,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item/* default */.Z, {
                                        id: "valabilitatea-cardului-cadou",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                    title: "Valabilitatea cardului cadou"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Body/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mb-5",
                                                    children: "Cardul cadou are o valabilitate de 12 luni de la data emiterii."
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item/* default */.Z, {
                                        id: "suma-minima-si-maxima-a-cardului",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                    title: "Suma minima si maxima a cardului"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Body/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mb-5",
                                                    children: "Cardurile cadou pot avea valoarea cuprinsa intre 200 si 5000 de lei."
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item/* default */.Z, {
                                        id: "regulament-privind-utilizarea-cardului",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                    title: "Regulament privind utilizarea cardului"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Body/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    className: "mb-5 list-[disc] list-inside",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Cardul Cadou poate fi utilizat imediat dupa emitere;"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Cardul Cadou Virtual se poate achizitiona DOAR singur in cos, fara alte produse/servicii in aceeasi comanda;"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Un client poate achizitiona mai multe Carduri Cadou Virtuale doar prin comenzi separate/individuale, pentru fiecare card in parte, iar fiecare comanda poate fi plasata doar fara alte produse/servicii in cosul de cumparaturi;"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Cardul Cadou Virtual poate fi utilizat in limita sumei incarcate pe acesta;"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Cardul Cadou Virtual nu se poate reincarca;"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: "Cardul Cadou Virtual nu se cumuleaza cu un alt Card Cadou Virtual pentru aceeasi comanda. Poate fi cumulat cu un cupon de cumparaturi sau mai multe cupoane care pot fi cumulate, in conditiile stabilite pentru fiecare campanie aplicabila, la aceeasi comanda."
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item/* default */.Z, {
                                        id: "intrebari-frecvente",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                    title: "Intrebari frecvente"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Body/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    className: "mb-5 list-[disc] list-inside",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "font-semibold",
                                                                    children: "Ce valabilitate are cardul cadou?"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: "Cardul cadou are o valabilitate de 12 luni de la data emiterii."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "font-semibold",
                                                                    children: "Ce valoare are cardul cadou?"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: "Cardurile cadou pot avea valoarea cuprinsa intre 200 si 5000 de lei."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "font-semibold",
                                                                    children: "Ce produse pot cumpara cu cardul cadou?"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: "Cardul cadou poate fi folosit la achizitionarea oricarui produs din oferta Altex, MediaGalaxy sau Brico mai putin Asigurari si Cartele Prepaid."
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    }));
};
GiftCard.pageLayout = "default";
/* harmony default export */ var card_cadou = ((0,es/* connect */.$j)(function(state) {
    return {
        user: state.user
    };
})(GiftCard));


/***/ }),

/***/ 73337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GU": function() { return /* binding */ OnChange; }
/* harmony export */ });
/* unused harmony exports ExternallyChanged, OnBlur, OnFocus */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_final_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66688);



function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var ExternallyChangedState =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ExternallyChangedState, _React$Component);

  function ExternallyChangedState(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      previous: props.input.value,
      externallyChanged: false
    };
    return _this;
  }

  var _proto = ExternallyChangedState.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var _this$props = this.props,
        value = _this$props.input.value,
        active = _this$props.meta.active;
    var previous = this.state.previous;

    if (value !== previous) {
      this.setState({
        previous: value,
        externallyChanged: !active
      });
    }
  };

  _proto.render = function render() {
    return this.props.children(this.state.externallyChanged);
  };

  return ExternallyChangedState;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);

var ExternallyChanged = function ExternallyChanged(_ref) {
  var name = _ref.name,
      children = _ref.children;
  return createElement(Field, {
    name: name,
    subscription: {
      active: true,
      value: true
    },
    allowNull: true,
    render: function render(props) {
      return createElement(ExternallyChangedState, _extends({}, props, {
        children: children
      }));
    }
  });
};

var OnBlurState =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(OnBlurState, _React$Component);

  function OnBlurState(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      previous: !!props.meta.active
    };
    return _this;
  }

  var _proto = OnBlurState.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var _this$props = this.props,
        children = _this$props.children,
        active = _this$props.meta.active;
    var previous = this.state.previous;

    if (previous && !active) {
      children();
    }

    if (previous !== active) {
      this.setState({
        previous: active
      });
    }
  };

  _proto.render = function render() {
    return null;
  };

  return OnBlurState;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);

var OnBlur = function OnBlur(_ref) {
  var name = _ref.name,
      children = _ref.children;
  return createElement(Field, {
    name: name,
    subscription: {
      active: true
    },
    render: function render(props) {
      return createElement(OnBlurState, _extends({}, props, {
        children: children
      }));
    }
  });
};

var OnChangeState =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(OnChangeState, _React$Component);

  function OnChangeState(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      previous: props.input.value
    };
    return _this;
  }

  var _proto = OnChangeState.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var _this$props = this.props,
        children = _this$props.children,
        value = _this$props.input.value;
    var previous = this.state.previous;

    if (value !== previous) {
      this.setState({
        previous: value
      });
      children(value, previous);
    }
  };

  _proto.render = function render() {
    return null;
  };

  return OnChangeState;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);

var OnChange = function OnChange(_ref) {
  var name = _ref.name,
      children = _ref.children;
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(react_final_form__WEBPACK_IMPORTED_MODULE_1__/* .Field */ .gN, {
    name: name,
    subscription: {
      value: true
    },
    allowNull: true,
    render: function render(props) {
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(OnChangeState, _extends({}, props, {
        children: children
      }));
    }
  });
};

var OnFocusState =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(OnFocusState, _React$Component);

  function OnFocusState(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      previous: !!props.meta.active
    };
    return _this;
  }

  var _proto = OnFocusState.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var _this$props = this.props,
        children = _this$props.children,
        active = _this$props.meta.active;
    var previous = this.state.previous;

    if (active && !previous) {
      this.setState({
        previous: active
      });
      children();
    } else if (!active && previous) {
      this.setState({
        previous: active
      });
    }
  };

  _proto.render = function render() {
    return null;
  };

  return OnFocusState;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);

var OnFocus = function OnFocus(_ref) {
  var name = _ref.name,
      children = _ref.children;
  return createElement(Field, {
    name: name,
    subscription: {
      active: true
    },
    render: function render(props) {
      return createElement(OnFocusState, _extends({}, props, {
        children: children
      }));
    }
  });
};




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(22209); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);